import { Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierConnectAvailableCarriers extends Layout {
    tableAvailableCarriers: Table;
}
